import React, { useState, useEffect } from 'react';
import { TextField, Box, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { getTransBizLocations } from 'src/views/setup/business/components/BizLocations/actions';
import DebounceTextField from 'src/components/DebounceTextField';

const LocationLookup = ({
  data,
  onChangeField,
  debounce = true,
  debounceDelay = 500
}) => {
  const { base_url, userToken } = useSelector(state => state.auth);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isValid, setIsValid] = useState(false);

  // Fetch business locations on mount
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        setLoading(true);
        const result = await getTransBizLocations({ base_url, userToken });
        if (result.success) {
          setLocations(result.data || []);
        }
      } catch (err) {
        console.error('Failed to fetch locations:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchLocations();
  }, [base_url, userToken]);

  // Validate location ID when value changes
  useEffect(() => {
    const value = data?.value;
    if (!value || value === 0) {
      setError('');
      setIsValid(false);
      return;
    }

    const locationExists = locations.some(
      loc => loc.ixLocation === parseInt(value)
    );
    if (locationExists) {
      setError('');
      setIsValid(true);
    } else {
      setError('Location not found');
      setIsValid(false);
    }
  }, [data?.value, locations]);

  const handleChange = e => {
    const value = e.target.value ? parseInt(e.target.value) : 0;
    if (onChangeField) {
      onChangeField({
        target: {
          name: data?.fld || data?.field || '',
          value
        }
      });
    }
  };

  const endAdornment = isValid ? (
    <Typography variant="caption" style={{ color: 'green', marginRight: 8 }}>
      ✓
    </Typography>
  ) : null;

  const InputComponent = debounce ? DebounceTextField : TextField;

  return (
    <InputComponent
      label={data?.caption || 'Location'}
      type="number"
      value={data?.value || ''}
      onChange={handleChange}
      name={data?.fld || data?.field || ''}
      disabled={data?.disabled || loading}
      error={!!error || data?.error}
      helperText={
        error || data?.errorMessage || (isValid ? 'Valid location' : '')
      }
      variant="outlined"
      fullWidth
      id={data?.fld || data?.field || ''}
      InputLabelProps={{
        shrink: true
      }}
      InputProps={{
        endAdornment
      }}
      delay={debounceDelay}
      {...(data?.rest || {})}
    />
  );
};

export default LocationLookup;
